import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageReviewStatus } from '@/api/model/interfaces';

export default class DrawingPackageReviewStatusOdata extends OdataManager<DrawingPackageReviewStatus> {}
